export enum Action {
    UPLOAD_SUMMARY,
    GET_ADDRESS,
    ACCOUNT_OPEN,
    DICTIONARIES,
    MOBILE_DOCUMENT_UPLOAD,
    GET_TOKEN,
    VALIDATE,
    NEW_ACCOUNT,
    LOGIN,
    DATA_UPLOAD_CHOICE,
    SELECT_MOBILE_DESKTOP,
    PERSONAL_DATA_CONFIRM,
    DESKTOP_DOCUMENT_SELECTION,
    UPLOAD_TRY_AGAIN,
    MOBILE_SMS,
    CHECK_IF_DESKTOP_CAN_PROCEED,
    DESKTOP_SMS,
    VERIFY_EMAIL,
    ADDRESS_DETAILS,
    CONFIRM_SMS_CODE,
    ACCOUNT_TYPE,
    TAX_OFFICE_DETAILS,
    CURRENCY,
    DECLARATION_ACCEPTANCE,
    CLINT_ZONE_LOGIN,
    PAYMENT,
    DESKTOP_DOCUMENT_UPLOAD,
    ABORT_MOBILE,
    MOBILE_DOCUMENT_SELECTION,
    MOBILE_RETURN_TO_DESKTOP,
    RISK_ASSESSMENT,
    MOBILE_SMS_CODE,
    CONFIRM_EMAIL,
    WRITE_ANALYTICS,
    SKIP_HYBRID_UPLOAD,
    MOBILE_QR_CODE_SCAN,
    GET_IDSCAN_TOKEN,
    NOTIFY_JOURNEY,
    GET_ALLOWED_ACCOUNT_TYPES,
    GET_ACCOUNT_TYPE,
    EXISTING_ACCOUNT,
    GET_CLIENT_COUNTRY
}

export enum SAME_TOKEN_ACTION {}

export enum ResponseStatus {
    SUCCESS = 'success',
    ERROR = 'error',
    CANCELLED = 'cancelled',
}
